var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info"},[_c('p',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.questionText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }